import { css } from "@emotion/react";

export const breadcrumbMixin = css`
  .breadcrumb {
    margin-bottom: 0;
  }
`;
